import { Pencil } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CommodityElements from './CommodityElements';

const GridItem = ({faq, i, j, setColumns, columns, disabled}) => {
    const [open, setOpen] = useState(false);
    const [data, setData]= useState(columns[i][j]);

    useEffect(()=>{
        setColumns((prev)=>{
            prev[i][j]=data;
            return [
                ...prev
            ];
        });
    },[data])
  
    const hasSelectCommodity = data.Select_Commodity !== undefined && data.Select_Commodity !== null && data.Select_Commodity !== "";

    return (
        <div className="border rounded-lg p-4 mb-4 shadow-sm bg-white">
            <div className="w-full text-left cursor-pointer" onClick={() => setOpen(!open)}>
                <div className='flex justify-between items-center space-x-2'>
                    {/* https://fodderlink.azurewebsites.net/Images/Img?id=5e2bdeaa-5a73-4763-b210-f45d7ae94a32 */}
                    <div className='flex items-center space-x-2 w-full'>
                        <img src={data.imgUrl} alt="" className='h-16' />
                        <div className='flex flex-col w-full'>
                            <span className='text-xs font-extralight'>{data.Status}</span>
                            <span className='font-semibold text-medium sm:text-lg'>{data.Product_Name}</span>
                            <span className='text-xs sm:text-xs font-light italic'>{data.updatedAt}</span>
                        </div>
                    </div>
                    {/* <button className='flex px-4 py-2 rounded-md space-x-1 items-center bg-lightblue-400 hover:bg-blue-500 text-white'>
                        <span className='text-sm'>Edit</span> */}
                        <Pencil className={`h-4 cursor-pointer ${open?"text-blue-500":"text-black hover:text-blue-700"}`} />
                    {/* </button> */}
                </div>
            </div>
            {open && 
                <>
                    <hr className='mt-3'/>
                    <div className='grid grid-cols-1 xl:grid-cols-2 text-xs gap-x-5 gap-y-2 mt-3 py-1'>
                        <div className='flex items-center space-x-3 justify-between'>
                            <span className='text-nowrap'>Grower Reference:</span>
                            <div className='w-fit p-1 outline-none rounded-sm text-center' >
                                {data.Grower_reference ?? "---"}
                            </div>
                        </div>
                        {/* <div className='flex items-center space-x-3 justify-between'>
                            <span className='text-nowrap'>Species:</span>
                            <div className='w-fit p-1 outline-none rounded-sm text-center' >
                                {data.Single_Species_Hay ?? "---"}
                            </div>
                        </div> */}
                        <div className='flex items-center space-x-3 justify-between'>
                            <span className='text-nowrap'>{hasSelectCommodity ? "Select Commodity" : "Commodity:"}</span>
                            <div className='w-fit p-1 outline-none rounded-sm text-center' >
                                {hasSelectCommodity ? (data.Select_Commodity ?? "---") : (data.Commodity ?? "---")}
                            </div>
                        </div>
                    </div>
                    <div className='flex space-x-2 mt-3 items-center justify-evenly w-full'>
                        <span className='text-xs font-semibold italic underline'>Species</span>
                        <hr className='h-[1px] w-full bg-gray-500'/>
                    </div>
                    <CommodityElements commodityData={data}/>
                    <hr className='mt-3'/>
                    <div className='grid grid-cols-1 xl:grid-cols-2 text-xs gap-4 mt-3 py-3'>
                        <div className='flex items-center space-x-3 justify-between'>
                            <span className='text-nowrap text-sm'>Tonnes Available:</span>
                            <input 
                                type="number" 
                                className='w-14 h-full p-1 outline-none border-[1px] border-gray-300 rounded-sm text-center text-sm' 
                                value={data.Tonnes}
                                onChange={(e)=>{setData((prev)=>{
                                    return {
                                        ...prev,
                                        Tonnes: e.target.value
                                    }
                                })}}
                                disabled={disabled}
                            />
                        </div>
                        <div className='flex items-center space-x-3 justify-between'>
                            <span className='text-nowrap text-sm'>Price:</span>
                            <input 
                                type="number" 
                                className='w-14 h-full p-1 outline-none border-[1px] border-gray-300 rounded-sm text-center text-sm' 
                                value={data.Purchase_Price}
                                onChange={(e)=>{setData((prev)=>{
                                    return {
                                        ...prev,
                                        Purchase_Price: e.target.value
                                    }
                                })}}
                                disabled={disabled}
                            />
                        </div>
                    </div>
                    <div className='flex flex-col mt-3 space-y-3'>
                        <span className='text-sm'>Additional Notes:</span>
                        <textarea className='rounded-md outline-none border-[1px] border-gray-300 p-2 text-xs' 
                            // value={data.Additional_notes} 
                            disabled={disabled}
                            onChange={(e)=>{setData((prev)=>{
                            return {
                                ...prev,
                                Additional_notes: (e.target.value).trim().length>1 ? e.target.value : data.Additional_notes
                            }
                        })}}/>
                    </div>
                </>
            }
        </div>
    );
};

export default GridItem;